import GigsSupport from "../../services/api/GigsSupport";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import qs from "qs";
import Errors from "../../constants/Errors.json";

const handleError = (err) => {
  console.log("[handleError] Error in GigsSupport actions", err);
};

export const setGigsSupportList = (payload) => {
  return {
    type: ActionTypes.SET_GIGS_SUPPORT_LIST,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_GIGS_SUPPORT,
    payload,
  };
};

export const setSlotHistoryDetail = (payload) => {
  return {
    type: ActionTypes.SET_SLOT_HISTORY_DETAIL,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_GIGS_SUPPORT,
    payload,
  };
};

export const getGigsSupportList =
  (filters = {}, mappingFilters) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...filters,
      };
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
        encode: false,
      });
      dispatch(setLoader(true));
      let response = await GigsSupport.getGigsSupportList(queryParamsString);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setGigsSupportList(response));
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
